module.exports = __webpack_public_path__ + "img/aliyun.bbb8420b.svg";